import { render } from "./VacanciesItem.vue?vue&type=template&id=724baa32&scoped=true"
import script from "./VacanciesItem.vue?vue&type=script&lang=js"
export * from "./VacanciesItem.vue?vue&type=script&lang=js"

import "./VacanciesItem.vue?vue&type=style&index=0&id=724baa32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724baa32"]])

export default __exports__